import { AffiliationTypes, BrandingId, CampaignStatus, DEFAULT_USER_SETTINGS, KnownOrganizationIds, KnownOrganizationNames, OrganizationType, PrimaryUserTypes, ServiceStatus, UserType } from "@madhive/mad-sdk";
/**
 * Mock user object for testing purposes
 * @internal
 */
export const MOCK_USER = {
    id: "userId",
    userId: "userId",
    name: "b",
    email: "b@madhive.com",
    type: UserType.DEV,
    isAdmin: false,
    isDev: true,
    affiliations: [],
    viewIds: [],
    primaryOrganizationId: KnownOrganizationIds.MADHIVE_DEFAULT,
    brandingId: BrandingId.MADHIVE,
    legacyAdvertiserId: null,
    legacyAgencyId: null,
    legacyTeamId: null,
    legacyUserId: null,
    settings: DEFAULT_USER_SETTINGS,
    primaryOrganizationName: KnownOrganizationNames.MADHIVE_DEFAULT,
    lastLoginDate: null,
    createdDate: null,
    affiliationType: AffiliationTypes.CORPORATE,
    userType: PrimaryUserTypes.INTERNAL_ADMIN,
    abilities: []
};
/**
 * Mock campaign object for testing purposes
 * @internal
 */
export const MOCK_CAMPAIGN = {
    id: "one",
    descendantsBookedImpressions: 0,
    creativesCount: 0,
    liveLineItemsCount: 0,
    owners: [],
    lineItems: [],
    isDoubleVerify: false,
    organizationId: "",
    isEditable: false,
    frequencies: [],
    name: "Mock Campaign",
    externalOrderManagementSystemId: "",
    externalId: "",
    instructionStatus: ServiceStatus.INVALID,
    version: 0,
    status: CampaignStatus.INVALID,
    statusDetails: {
        canBe: { archived: true, unarchived: false, live: false, edited: true, paused: false },
        code: 0,
        summary: CampaignStatus.INVALID
    },
    parent: "",
    parentName: "",
    isLive: () => {
        throw new Error("Function not implemented.");
    }
};
/**
 * Mock creative object for testing purposes
 * @internal
 */
export const MOCK_CREATIVE = {
    id: "a",
    name: "Mock Creative",
    clickThroughUrl: "https://yahoo.com",
    advertiserId: "adid"
};
/**
 * Mock organization object for testing purposes
 * @internal
 */
export const MOCK_ORGANIZATION = {
    id: "a",
    name: "Mock Organization",
    type: OrganizationType.AGENCY
};
/**
 * Mock advanced export template for testing purposes
 * @internal
 */
export const MOCK_TEMPLATE = {
    name: "mock template",
    dimensions: ["a", "b", "c"],
    metrics: ["a", "b", "c"],
    filters: { advertiser: ["mcdonalds"] },
    id: "abc",
    created_at: new Date().toString(),
    updated_at: new Date().toString()
};
/**
 * Mock report schedule for testing purposes
 * @internal
 */
export const MOCK_REPORT_SCHEDULE = {
    id: "id_1",
    name: "test",
    cadence: "WEEKLY",
    template_id: "template_id_1",
    emails: ["test@email.com"],
    filters: {},
    status: "READY",
    user_id: "user_id_1",
    org_id: "org_id_1",
    next_run: "2023-07-25T00:00:00Z",
    created_at: "2023-07-20T15:05:08Z",
    updated_at: "2023-07-20T15:05:08Z"
};
/**
 * Mock template dimensions for testing purposes
 * @internal
 */
export const MOCK_TEMPLATE_DIMENSIONS = [
    {
        id: "1",
        label: "dimension-one"
    },
    {
        id: "2",
        label: "dimension-two"
    },
    {
        id: "3",
        label: "dimension-three"
    }
];
/**
 * Mock template metrics for testing purposes
 * @internal
 */
export const MOCK_TEMPLATE_METRICS = [
    {
        id: "1",
        label: "metric-one"
    },
    {
        id: "2",
        label: "metric-two"
    },
    {
        id: "3",
        label: "metric-three"
    }
];
/**
 * Mock template filters for testing purposes
 * @internal
 */
export const MOCK_TEMPLATE_FILTERS = [
    {
        id: "1",
        label: "filter-one"
    },
    {
        id: "2",
        label: "filter-two"
    },
    {
        id: "3",
        label: "filter-three"
    }
];
//# sourceMappingURL=mocks.js.map